import React from 'react';
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";
const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Plan",
    description:
      "We use scrum methodologies to construct a path for development, prioritizing items from the product backlog.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Design",
    description:
      "We craft a user-friendly and visually appealing user interface in this phase.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Build",
    description:
      "Our React Native app developers transform the design into a functional Android app using recent tech-stack.",
    count: "03",
  },
  {
    logo: TestIcon,
    title: "Test",
    description:
      "To ensure your app works properly, rigorous testing is conducted to identify and rectify any bugs.",
    count: "04",
  },
  {
    logo: LaunchIcon,
    title: "Launch",
    description:
      "Your react-native app is ready to make its debut on your preferred platform, reaching its intended audience.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Deployment",
    description:
      " We provide ongoing support and updates to keep your app up-to-date and responsive to the needs.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100 tekrevol_gray_bg">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Our React Native Mobile App Development Process <span>Workflow</span>{" "}
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              In the dynamic world of React Native mobile application development, every project has unique requirements that separate it from the rest. As your trusted React native app development partner, we ensure your product reflects the uniqueness of your novelty and advanced concepts.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
